
import Utility from '@/components/Passenger/models/Utility';
import RideitChangeRequest, { RideitChangeRequestStatus } from '@/models/Rideit/RideitChangeRequest';
import { IDataTableHeader } from '@/typings/dataTable';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class RideitChangeRequestTableItem extends Vue {
  @Prop({ required: true }) private item: RideitChangeRequest;
  @Prop({ required: true }) private headers: IDataTableHeader[];
  @Prop({ default: () => [] }) private utilityOptions: Utility[];

  // get requestTitles() {
  //   const ids = this.item.request.split(',').map(s => parseInt(s.trim()));
  //   return this.utilityOptions
  //     .filter(u => ids.includes(u.id))
  //     .map(u => this.$i18n.translate('utility.title.' + u.title, u.title))
  //     .join(', ');
  // }

  get statusColor() {
    switch (this.item.status) {
      case RideitChangeRequestStatus.Approved: return 'success';
      case RideitChangeRequestStatus.Rejected: return 'error';
      default: return 'warning';
    }
  }
}
